import { ITranslations } from 'types/common';
import { ProductFormTransFields } from './types';
import en from 'translations/en/productForm.json';
import pl from 'translations/pl/productForm.json';
import sl from 'translations/sl/productForm.json';

export const productFormTranslations: ITranslations<ProductFormTransFields> = {
  name: 'productForm',
  en,
  pl,
  sl,
};
